import { useState } from "react";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

//components
import Header from "./Header";
import Sidebar from "components/layouts/adminLayout/Sidebar";
import HeaderPrint from "components/HeaderPrint";

const APP_BAR_MOBILE = 70;
const APP_BAR_DESKTOP = 92;

const MainStyle = styled("main")(({ theme }) => ({
  flexGrow: 1,
  minHeight: `calc(100vh - ${APP_BAR_DESKTOP + 1}px)`,
  paddingTop: APP_BAR_MOBILE + 30,
  paddingBottom: theme.spacing(5),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 20,
  },
  "@media print": {
    paddingTop: 20,
    paddingBottom: 10,
    paddingLeft: 15,
    paddingRight: 15,
    minHeight: "auto",
  },
}));

export default function DashboardLayout({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

      <Box sx={{ flex: 1 }}>
        <Header onOpenSidebar={() => setOpen(true)} />
        <HeaderPrint />
        <MainStyle>{children || <Outlet />}</MainStyle>
      </Box>
    </Box>
  );
}
